import Grid from '@material-ui/core/Grid';
import React from 'react';
import { OPTION_STATUS } from '../constants';
import CheckBoxTouchButton from './CheckBoxTouchButton';

type GridColumns = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type Props = {
  value: any;
  lastSelectedValues?: any[];
  options: any[];
  onChange: (isChecked: boolean, option: any) => void;
  getOptionId: (option: any) => string | undefined;
  getOptionLabel: (option: any) => string | undefined;
  isDisabled?: (option: any) => boolean;
  isSelected?: (option: any) => boolean;
  fullWidth?: boolean;
  getTag?: (option: any) => any | undefined;
  customStyle?: boolean;
  getOptionWidth?: (
    option: any,
    id: string,
    label: string,
    isMobile?: boolean
  ) => GridColumns;
};

const CheckBoxTouchGroup: React.FC<Props> = ({
  value,
  lastSelectedValues = [],
  options = [],
  onChange,
  getOptionId,
  getOptionLabel,
  fullWidth = false,
  isDisabled = () => false,
  getTag,
  isSelected = (option) =>
    value?.some(
      (selectedValue) =>
        selectedValue?.valueCoding?.code === option?.code ||
        selectedValue?.code === option?.code
    ),
  customStyle,
  getOptionWidth,
}) => {
  const getOptionVariant = (option: fhir.CodeableConcept) => {
    const previouslySelected = lastSelectedValues?.some(
      (value) => getOptionId(option) === getOptionId(value)
    );
    if (isSelected(option) && previouslySelected) {
      return OPTION_STATUS.selectedAgain;
    } else if (isSelected(option)) {
      return OPTION_STATUS.selected;
    } else if (previouslySelected) {
      return OPTION_STATUS.lastSelected;
    } else {
      return OPTION_STATUS.unSelected;
    }
  };

  const getColumnXS = (option, id, label): GridColumns => {
    if (getOptionWidth) {
      return getOptionWidth(option, id, label, true);
    }
    return 12;
  };

  const getColumnSM = (option, id, label): GridColumns => {
    if (fullWidth) return 12;
    if (getOptionWidth) {
      return getOptionWidth(option, id, label);
    }
    if (label.length > 30) {
      return 12;
    } else if (label.length > 20) {
      return 8;
    } else if (label.length > 8) {
      return 6;
    } else {
      return 3;
    }
  };

  const getColumnMD = (option, id, label): GridColumns => {
    if (fullWidth) return 12;
    if (getOptionWidth) {
      return getOptionWidth(option, id, label);
    }
    if (label.length > 40) {
      return 12;
    } else if (label.length > 15) {
      return 8;
    } else {
      return 4;
    }
  };
  const getColumnXL = (option, id, label): GridColumns => {
    if (fullWidth) return 12;
    if (getOptionWidth) {
      return getOptionWidth(option, id, label);
    }
    if (label.length > 40) {
      return 9;
    } else if (label.length > 15) {
      return 6;
    } else {
      return 3;
    }
  };

  return (
    <Grid container spacing={2}>
      {options.map((option, i) => {
        const optionLabel = getOptionLabel(option) || '';
        const optionId = getOptionId(option) || '';
        return (
          <Grid
            item
            key={optionId + i}
            xs={getColumnXS(option, optionId, optionLabel)}
            sm={getColumnSM(option, optionId, optionLabel)}
            md={getColumnMD(option, optionId, optionLabel)}
            xl={getColumnXL(option, optionId, optionLabel)}
          >
            <CheckBoxTouchButton
              label={optionLabel || option?.display}
              onClick={(isChecked) => onChange(isChecked, option)}
              variant={getOptionVariant(option)}
              disabled={isDisabled(option)}
              tag={getTag && getTag(option)}
              customStyle={customStyle}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default React.memo(CheckBoxTouchGroup);
